import React, { useCallback, useState } from 'react';
import "./HomeCSShortcut.css";
import ApiServices from "../../utils/apiServices";
import { useEffect } from 'react';
import { Popover } from 'react-tiny-popover';
import trackingService from "../../services/trackingService";
import ScientificCommunicationDocumentsTileGenAIRecom from "../ContentShortCutGenAI/ScientificCommunicationDocumentTitleGenAIRecom";
import {
    imsLoader
} from "../../assets";
import LabelingDocumentsGenAIRec from "../ContentShortCutGenAI/LabelingDocumentGenAIRec";
import MedicalInsightTileGenAIRec from "../ContentShortCutGenAI/MedicalInsightTileGenAIRec";
import KeyMedicalLitDocTileGenAiRec from "../ContentShortCutGenAI/KeyMedicalLitDocTileGenAIRec";
import SubmissionRelatedClinicalSafteyGenAIRec from "../ContentShortCutGenAI/SubmissionRelatedClinicalSafteyGenAIRec";
import KeyCongressLitGenAIRec from "../ContentShortCutGenAI/KeyCongressLitGenAIRec";
import EducationandTrainingDocGenAIRec from "../ContentShortCutGenAI/EducationalTrainingDocGenAIRec";
import CopyReviewPiecesGenAIRec from "../ContentShortCutGenAI/CopyReviewPiecesGenAIRec";
import TAamdDiseasesGenAIRec from '../ContentShortCutGenAI/TAandDiseasesGenAIRec';
import AdministrationAndDosagesGenAIRec from '../ContentShortCutGenAI/AdministrationAndDosagesGenAIRec';
import EstablishedProductGenAIRec from '../ContentShortCutGenAI/EstablishedProductGenAIRec';
import MCETTemplatesDocumentsTile from '../ContentShortCutGenAI/MCETTemplatesDocumentsTile';
import GMAFGenAIRec from '../ContentShortCutGenAI/GMAFGenAIRec';
import axios from "axios";
import { LocationOrigin } from "../../utils/utilityServices";
import { Authentication } from "../../utils/authenticationUtilityServices";
import { ContextMenu, MenuItem, ContextMenuTrigger, showMenu, hideMenu } from "react-contextmenu";
import ConfirmMessagePopUpModal from "../GenAIPopUp/ConfirmMessagePopUpModal";

/**
 * HomeCSShortcut
 * - Renders a row of pill cards.
 * - All CSS class names are prefixed with "cs-hs-".
 *
 * Props:
 * - items: Array<{ id?: string|number, title: string, subtitle?: string }>
 */
export default function HomeCSShortcut({ customWidth, customHeight, _isLoaded, SavedShortcutsScrollTimeStamp, updateSCAddForHome, SavedShortcuts = [] }) {
    const [showAnDCSModal, setShowAnDCSModal] = useState(false);
    const [showSRnCSModal, setShowSRnCSModal] = useState(false);
    const [showEnTCSModal, setShowEnTCSModal] = useState(false);
    const [showKMLCSModal, setShowKMLCSModal] = useState(false);
    const [showKCLCSModal, setShowKCLCSModal] = useState(false);
    const [showLDCSModal, setShowLDCSModal] = useState(false);
    const [showSCDCSModal, setShowSCDCSModal] = useState(false);
    const [showCRPCSModal, setShowCRPCSModal] = useState(false);
    const [showTAnDCSModal, setShowTAnDCSModal] = useState(false);
    const [showEPCSModal, setShowEPCSModal] = useState(false);
    const [showMIRCSModal, setShowMIRCSModal] = useState(false);
    const [showMCECSModal, setShowMCECSModal] = useState(false);
    const [showGMAFCSModal, setShowGMAFCSModal] = useState(false);
    const [McetList, setMcetList] = useState([]);
    const [isLoaded, setisLoaded] = useState(_isLoaded);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [selectedUniqueKey, setSelectedUniqueKey] = useState("");
    const [openedContextMenuId, setOpenedContextMenuId] = useState("");
    const [GMAFProducts, setGMAFProducts] = useState([]);

    useEffect(async () => {
        await closeAllModal();
        hideMenu(openedContextMenuId)
        setOpenedContextMenuId("");
    }, [SavedShortcutsScrollTimeStamp]);
    useEffect(async () => {
        let service = new ApiServices();
        let wwid = JSON.parse(localStorage.getItem('wwid'));
        let isProductsAvailable;
        await runSearch();
        await getDCSVVProducts();
        let res = await service.getUserProductAndWwid(wwid);
        if (res) {
            isProductsAvailable = res[0].products;
        }
        if (isProductsAvailable !== null && isProductsAvailable?.length > 0) {
            setProducts(isProductsAvailable.split(";"));
            setisLoaded(true);
        } else {
            setisLoaded(true);
        }

    }, []);
    useEffect(() => {
        if (!selectedProduct && (products && products.length > 0)) {
            setSelectedProduct(products[0])
        }
    }, [products]);
    const urlGenerator = (item) => {
        let url = ``;
        let { orderedBy, orderedFor } = item;
        if (!orderedBy) orderedBy = '';
        if (!orderedFor) orderedFor = '';
        if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            // url = `/DocURL?ID=${item.docTitle}&cs=${item.domain}`
        }
        else if (item.domain === 'SKM' || item.domain === "MIAs") {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
        }
        else if (item.domain === 'EmeaEPs') {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
        }
        else {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
                url = url + `&docState=anr`
            }
        }
        if (item.enclosureDocID) {
            url += `&enclosureID=${item.enclosureDocID}`
        }

        return url
    }
    const runSearch = async () => {
        var url = LocationOrigin + process.env.REACT_APP_IMS_API_PREFIX + 'qp/runSearch'
        var config;

        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: {
                // "from": 0,
                // "size": 25,
                "f1": "csID",
                "fval1": "46",
                "fcount": 1,
                "source": "connID;csID;docID;fileExtension;majorVersionNumber;fileName;docTitle;status;domain;enclosureDocID;searchID;documentNumber;",
                sortBy: "asc",
                sortField: "docTitle",
            }
        }
        axios(config)
            .then((response) => {
                if (response.data.body.hits.total.value > 0 && response.data.body &&
                    response.data.body.hits && response.data.body.hits.hits) {
                    let firstmcettlist = response.data.body.hits.hits.filter(x => x._source.documentNumber === "US-SFM-7624");
                    let othermcettlist = response.data.body.hits.hits.filter(x => x._source.documentNumber !== "US-SFM-7624");
                    let _mcettList = firstmcettlist.concat(othermcettlist).map(x => { return { docTitle: x._source.docTitle, docURL: urlGenerator(x._source) } });
                    setMcetList(_mcettList);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
    }
    const getDCSVVProducts = useCallback(async () => {

        var url = LocationOrigin + '/api/dcs-vv/get-products?csid=47'
        var config;

        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        config = {
            method: 'GET',
            url: url,
            headers: _headers,

        }
        return axios(config)
            .then((response) => {
                if (response.data && response.data.status && response.data.status === "SUCCESS") {
                    setGMAFProducts(response.data.products)
                }
                else {
                    setGMAFProducts([])
                }
                //console.log("response", response)
            })
            .catch(function (error) {
                if (window.location.origin === 'http://localhost:3000'
                    || window.location.origin === 'https://predev-ims.jnj.com') {
                    setGMAFProducts(["ACI-JEL","ACIPHEX","AKEEGA","Abiraterone Acetate","DARZALEX","DARZALEX SC","INLEXZO","No Product","REMICADE","TALVEY","aberela","achillion HCV compounds"])
                }
                else {
                    setGMAFProducts([])
                }

                console.log(error);
            })
    }, []);
    const handleCSKP = () => {
        let url = `/CSKP`;
        window.open(
            url,
            "",
            `width=${window.innerWidth},height=${window.innerHeight},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`
        );
    };
    const closeAllModal = async () => {
        await setSelectedUniqueKey("");
        await setShowAnDCSModal(false);
        await setShowSRnCSModal(false);
        await setShowKMLCSModal(false);
        await setShowEnTCSModal(false);
        await setShowKCLCSModal(false);
        await setShowLDCSModal(false);
        await setShowSCDCSModal(false);
        await setShowCRPCSModal(false);
        await setShowTAnDCSModal(false);
        await setShowEPCSModal(false);
        await setShowMIRCSModal(false);
        await setShowMCECSModal(false);
        await setShowGMAFCSModal(false);
    }
    const indexTrackingData = (uniqueKey) => {
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            keyValueForCS[uniqueKey],//"Expanded Established Products tile under content shortcuts",
            "",
            window.location.href
            //   this.state.searchKeyword,
            //   this.props.appliedFilters
        );
    }
    const handleDeleteExisting = async (_id) => {
        setisLoaded(false);
        let wwid = JSON.parse(localStorage.getItem('wwid'));
        let service = new ApiServices();
        await service.deleteAddToHomePageByCSKey(wwid, _id)
            .then(async (response) => {
                await updateSCAddForHome();
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setisLoaded(true);
            });
    }
    const handleOnOpenedContextMenuClick = async (_id) => {
        setOpenedContextMenuId(_id)
        await closeAllModal();
    }
    const handelSCCardDetail = async (e, uniqueKey, isClicked) => {
        await closeAllModal();
        if (!(e.target && e.target.classList && e.target.classList.contains('ContextMenuItem'))) {
            if (isClicked) {
                setSelectedUniqueKey(uniqueKey)
                indexTrackingData(uniqueKey)
            }

            if (uniqueKey === "SCDCS") {
                setShowSCDCSModal(isClicked)
            }
            else if (uniqueKey === "LDCS") {
                setShowLDCSModal(isClicked)
            }
            else if (uniqueKey === "MIRCS") {
                setShowMIRCSModal(isClicked)
            }
            else if (uniqueKey === "KMLCS") {
                setShowKMLCSModal(isClicked)
            }
            else if (uniqueKey === "SRnCS") {
                setShowSRnCSModal(isClicked)
            }
            else if (uniqueKey === "KCLCS") {
                setShowKCLCSModal(isClicked)
            }
            else if (uniqueKey === "EnTCS") {
                setShowEnTCSModal(isClicked);
            }
            else if (uniqueKey === "CRPCS") {
                setShowCRPCSModal(isClicked);
            }
            else if (uniqueKey === "CSKPCS") {
                handleCSKP();
            }
            else if (uniqueKey === "TAnDCS") {
                setShowTAnDCSModal(isClicked);
            }
            else if (uniqueKey === "AnDCS") {
                setShowAnDCSModal(isClicked);
            }
            else if (uniqueKey === "EPCS") {
                setShowEPCSModal(isClicked);
            }
            else if (uniqueKey === "MCECS") {
                setShowMCECSModal(isClicked);
            }
            else if (uniqueKey === "GMAFCS") {
                setShowGMAFCSModal(isClicked);
            }
        }
    }
    return (<>
        <div className="cs-hs-list" role="list">
            {isLoaded ? <>
                {SavedShortcuts.map((item, cIdx) => {
                    let _positions = ['top'];
                    let _align = 'start'
                    if (cIdx === 3) {
                        _positions = ['top', 'left'];
                        _align = 'end';
                    }
                    return (<React.Fragment key={`cs-hs-item-${cIdx}`}>
                        <Popover
                            isOpen={selectedUniqueKey === item.uniqueKey}
                            // positions={_positions}
                            positions={['top', 'bottom', 'left', 'right']}
                            align={_align}
                            reposition={false}
                            scrollable
                            containerClassName='cs-shortcut-popover-container popoverAvoidClickOutside'
                            onClickOutside={(e) => {
                                if (!(e && e.srcElement && e.srcElement.classList &&
                                    (e.srcElement.classList.contains('popoverAvoidClickOutside') ||
                                        e.srcElement.closest(".react-tiny-popover-container") ||
                                        e.srcElement.closest(".popoverAvoidClickOutside")))) {
                                    closeAllModal();
                                }
                            }} // This is the key!
                            content={(positions, align) => (<>
                                {selectedUniqueKey === "SCDCS" &&
                                    <ScientificCommunicationDocumentsTileGenAIRecom
                                        isFiltersShow={false}
                                        handelSCDCardDetail={(e) => handelSCCardDetail(e, "SCDCS", e)}
                                        showSCDCSModal={showSCDCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />}
                                {selectedUniqueKey === "LDCS" &&
                                    <LabelingDocumentsGenAIRec
                                        isFiltersShow={false}
                                        handelLDCardDetail={(e) => handelSCCardDetail(e, "LDCS", e)}
                                        showLDCSModal={showLDCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />}

                                {selectedUniqueKey === "MIRCS" &&
                                    <MedicalInsightTileGenAIRec
                                        isFiltersShow={false}
                                        handelMIRCardDetail={(e) => handelSCCardDetail(e, "MIRCS", e)}
                                        showMIRCSModal={showMIRCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                    />
                                }
                                {selectedUniqueKey === "KMLCS" &&
                                    <KeyMedicalLitDocTileGenAiRec
                                        isFiltersShow={false}
                                        handelKMLCardDetail={(e) => handelSCCardDetail(e, "KMLCS", e)}
                                        showKMLCSModal={showKMLCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />}
                                {selectedUniqueKey === "SRnCS" &&
                                    <SubmissionRelatedClinicalSafteyGenAIRec
                                        isFiltersShow={false}
                                        handelSRnCSCardDetail={(e) => handelSCCardDetail(e, "SRnCS", e)}
                                        showSRnCSModal={showSRnCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />
                                }
                                {selectedUniqueKey === "KCLCS" &&
                                    <KeyCongressLitGenAIRec
                                        isFiltersShow={false}
                                        handelKCLCardDetail={(e) => handelSCCardDetail(e, "KCLCS", e)}
                                        showKCLCSModal={showKCLCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />
                                }
                                {selectedUniqueKey === "EnTCS" &&
                                    <EducationandTrainingDocGenAIRec
                                        isFiltersShow={false}
                                        handelEnTCardDetail={(e) => handelSCCardDetail(e, "EnTCS", e)}
                                        showEnTCSModal={showEnTCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />
                                }
                                {selectedUniqueKey === "CRPCS" &&

                                    <CopyReviewPiecesGenAIRec
                                        isFiltersShow={false}
                                        handelCRPCardDetail={(e) => handelSCCardDetail(e, "CRPCS", e)}
                                        showCRPCSModal={showCRPCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />
                                }
                                {selectedUniqueKey === "TAnDCS" &&
                                    <TAamdDiseasesGenAIRec
                                        isFiltersShow={false}
                                        handelTADCardDetail={(e) => handelSCCardDetail(e, "TAnDCS", e)}
                                        showSCDCSModal={showSCDCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />
                                }
                                {selectedUniqueKey === "AnDCS" &&

                                    <AdministrationAndDosagesGenAIRec
                                        isFiltersShow={false}
                                        handelCRPCardDetail={(e) => handelSCCardDetail(e, "AnDCS", e)}
                                        showCRPCSModal={showAnDCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />
                                }
                                {selectedUniqueKey === "EPCS" &&

                                    <EstablishedProductGenAIRec
                                        isFiltersShow={false}
                                        handelEPCardDetail={(e) => handelSCCardDetail(e, "EPCS", e)}
                                        showEPCSModal={showEPCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                    />
                                }
                                {selectedUniqueKey === "GMAFCS" &&
                                    <GMAFGenAIRec
                                        isFiltersShow={false}
                                        handelGMAFCardDetail={(e) => handelSCCardDetail(e, "GMAFCS", e)}
                                        showGMAFCSModal={showGMAFCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                        GMAFProducts={GMAFProducts}
                                    />
                                }
                                {selectedUniqueKey === "MCECS" &&
                                    <MCETTemplatesDocumentsTile
                                        isFiltersShow={false}
                                        showEPCSModal={showEPCSModal}
                                        customWidth={customWidth}
                                        customHeight={customHeight}
                                        products={products}
                                        selectedProduct={selectedProduct}
                                        handelMCETCardDetail={(e) => handelSCCardDetail(e, "MCECS", e)}
                                        showMCECSModal={showMCECSModal}
                                        mcetList={McetList}
                                    />
                                }
                            </>
                            )}>
                            {/* <div style={{ visibility: "hidden" }} /> */}
                            {/* <div
                                key={item.uniqueKey ?? item.title}
                                type="button"
                                className="cs-hs-pill popoverAvoidClickOutside"
                                aria-label={`${item.title} ${item.title ?? ""}`}
                                onClick={(e) => handelSCCardDetail(e, item.uniqueKey, true)}>
                                <div className="cs-hs-title popoverAvoidClickOutside">{item.title}</div>
                                {item.subtitle && <div className="cs-hs-sub popoverAvoidClickOutside">{item.subtitle}</div>}
                            </div> */}
                            <div>
                                <ContentShortcut it={item} handelSCCardDetail={handelSCCardDetail}
                                    handleDeleteExisting={handleDeleteExisting}
                                    handleOnOpenedContextMenuClick={handleOnOpenedContextMenuClick}
                                    openedContextMenuId={openedContextMenuId}
                                />
                            </div>
                        </Popover>

                        {/* <ContentShortcut it={item} key={item.uniqueKey ?? item.title} handelSCCardDetail={handelSCCardDetail} /> */}
                    </React.Fragment>
                    )
                }
                )}</> : <div style={{ textAlign: "center" }}>
                <img src={imsLoader} alt="Loading Data" style={{ width: "100px" }} />
            </div>}
        </div>
    </>
    );
}

const ContentShortcut = ({ it, handelSCCardDetail, openedContextMenuId, handleOnOpenedContextMenuClick, handleDeleteExisting }) => {
    const [confirmMessageContent, setConfirmMessageContent] = useState('');
    const [confirmMessageShowModal, setConfirmMessageShowModal] = useState(false);
    const [confirmMessageId, setConfirmMessageId] = useState(-1);

    const showConfirmMessage = (message, id) => {
        // handelSCCardDetail("", it.uniqueKey, false)
        setConfirmMessageContent(message);
        setConfirmMessageShowModal(true);
        setConfirmMessageId(id);
    }
    const confirmHandler = async () => {
        setConfirmMessageContent("");
        setConfirmMessageShowModal(false);
        setConfirmMessageId(-1);
        handleDeleteExisting(it.uniqueKey)
    }
    const closeConfirmMessage = () => {
        setConfirmMessageContent("");
        setConfirmMessageShowModal(false);
        setConfirmMessageId(-1);
    }
    useEffect(() => {
        if (openedContextMenuId != `CS-HS-${it.sort}`) {
            hideMenu({
                id: `CS-HS-${it.sort}`
            });
        }
    }, [openedContextMenuId]);
    const handleLeftMouseClick = (e, _id) => {
        e.stopPropagation();
        const x = e.clientX;
        const y = e.clientY;
        handleOnOpenedContextMenuClick(_id);
        showMenu({
            position: { x, y },
            id: _id
        });

    }
    const onContextMenuHide = () => {
        handleOnOpenedContextMenuClick("");
    }


    return (<><div
        key={it.uniqueKey ?? it.title}
        type="button"
        className="cs-hs-pill popoverAvoidClickOutside"
        aria-label={`${it.title} ${it.title ?? ""}`}
        onClick={(e) => handelSCCardDetail(e, it.uniqueKey, true)}
    >
        <div className='cs-hs-cardAccentMarker' aria-hidden="true" >
            <ContextMenuTrigger id={`CS-HS-${it.sort}`}>
                <button className='cs-hs-view-more' title='More Option'
                    onClick={e => { handleLeftMouseClick(e, `CS-HS-${it.sort}`) }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99971 8.66666C8.36789 8.66666 8.66636 8.36818 8.66636 7.99999C8.66636 7.6318 8.36789 7.33332 7.99971 7.33332C7.63154 7.33332 7.33307 7.6318 7.33307 7.99999C7.33307 8.36818 7.63154 8.66666 7.99971 8.66666Z" stroke="#81766F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.99971 3.99999C8.36789 3.99999 8.66636 3.70151 8.66636 3.33332C8.66636 2.96513 8.36789 2.66666 7.99971 2.66666C7.63154 2.66666 7.33307 2.96513 7.33307 3.33332C7.33307 3.70151 7.63154 3.99999 7.99971 3.99999Z" stroke="#81766F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.99971 13.3333C8.36789 13.3333 8.66636 13.0348 8.66636 12.6667C8.66636 12.2985 8.36789 12 7.99971 12C7.63154 12 7.33307 12.2985 7.33307 12.6667C7.33307 13.0348 7.63154 13.3333 7.99971 13.3333Z" stroke="#81766F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </ContextMenuTrigger>
            <ContextMenu id={`CS-HS-${it.sort}`} onHide={e => { onContextMenuHide(e) }} className="cs-hs-item-contextMenu">
                <MenuItem onClick={() => {
                    showConfirmMessage("Are you sure you want to remove this content shortcut from home screen?", it.uniqueKey)
                    //  handleDeleteExisting(it.uniqueKey) 

                }}>
                    <svg className='ContextMenuItem' style={{ fontSize: "12px" }} aria-hidden="true" focusable="false" data-prefix="far" data-icon="trash" class="svg-inline--fa fa-trash fa-fw " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <path className='ContextMenuItem' fill="currentColor" d="M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z">
                        </path>
                    </svg>
                    &nbsp;
                    <span className='ContextMenuItem' style={{ fontSize: "12px" }}>Remove From Home Screen</span>
                </MenuItem>
            </ContextMenu>
        </div>
        <div className="cs-hs-title popoverAvoidClickOutside">{it.title}</div>
        {it.subtitle && <div className="cs-hs-sub popoverAvoidClickOutside">{it.subtitle}</div>}
    </div>
        {
            confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => closeConfirmMessage()} handleConfirm={() => confirmHandler()} />
        }
    </>)
}

const keyValueForCS = {
    SCDCS: "Expanded Scientific Communication Documents tile under content shortcuts",
    LDCS: "Expanded Labeling Documents tile under content shortcuts",
    MIRCS: "Expanded iMedical Insights Reports tile under content shortcuts",
    KMLCS: "Expanded Key Medical Literature Documents tile under content shortcuts",
    SRnCS: "Expanded Submission-Related and Clinical Safety Documents tile under content shortcuts",
    TAnDCS: "Expanded TA and Disease Dashboards tile under content shortcuts",
    KCLCS: "Expanded Key Congress Literature Documents tile under content shortcuts",
    CSKPCS: "Expanded Clinical Studies Knowledge Panel tile under content shortcuts",
    EnTCS: "Expanded Education & Training Documents tile under content shortcuts",
    CRPCS: "Expanded Copy Review Pieces tile under content shortcuts",
    AnDCS: "Expanded Routes of Administration and Dosages tile under content shortcuts",
    EPCS: "Expanded Established Products tile under content shortcuts",
    MCECS: "Expanded MCET Templates tile under content shortcuts",
    GMAFCS: "Expanded GMAF tile under content shortcuts",
}